import { KalturaLanguageFilter, LanguageListAction } from '@kaltura-ott/ott-client-types/api/types';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { kalturaClient } from './kaltura-clent';

export const languageList = () => {
  const client = kalturaClient();
  const action = new LanguageListAction({
    filter: new KalturaLanguageFilter(),
  });
  return client.request(action).pipe(
    catchError((error) => {
      console.trace(error);
      return throwError(error);
    }),
  );
};
